import { TaskTemplate } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const mockTaskTemplates: TaskTemplate[] = [
  {
    id: '1',
    name: 'Task template 1',
    description: 'This is first template',
    grantProgramId: 'program_123',
    dueByDate: '2021-01-01',
    possibleStatuses: ['Todo', 'Done'],
    details: { type: 'review', formId: 'form_123' },
    audience: 'partner'
  },
  {
    id: '2',
    name: 'Task template 2',
    description: 'This is second template',
    grantProgramId: 'program_123',
    hoursUntilDue: 2,
    possibleStatuses: ['Todo', 'Done'],
    details: { type: 'bank_details' },
    audience: 'organisation'
  }
]
